// A small line (24 h) for the "now" cards: stretched to the card width, breaks at gaps, optional area and
// dashed 0 line.
import * as React from 'react';

import { Point } from '../../util/rrd';

const W = 100;
const H = 40;

export function Sparkline(props: {
  points: Point[];
  color: string;
  height: number;
  area?: boolean;
  zeroLine?: boolean;
  style?: React.CSSProperties;
}): React.ReactElement | null {
  const pts = props.points.filter((p) => p[1] !== null) as [number, number][];
  if (pts.length < 2) {
    return null;
  }
  const t0 = props.points[0][0];
  const t1 = props.points[props.points.length - 1][0];
  const values = pts.map((p) => p[1]);
  const lo = Math.min(...values) - 0.3;
  const hi = Math.max(...values) + 0.3;
  const x = (t: number) => (((t - t0) / (t1 - t0 || 1)) * W).toFixed(1);
  const y = (v: number) => (H - ((v - lo) / (hi - lo)) * H).toFixed(1);
  let line = '';
  let pen = false;
  for (const [t, v] of props.points) {
    if (v === null) {
      pen = false;
      continue;
    }
    line += `${pen ? 'L' : 'M'}${x(t)} ${y(v)}`;
    pen = true;
  }
  const stroke = {
    fill: 'none',
    vectorEffect: 'non-scaling-stroke',
    strokeLinejoin: 'round',
    strokeLinecap: 'round',
  } as const;
  return (
    <svg
      viewBox={`0 0 ${W} ${H}`}
      preserveAspectRatio="none"
      aria-hidden="true"
      style={{ display: 'block', width: '100%', height: props.height, ...props.style }}
    >
      {props.zeroLine && lo < 0 && hi > 0 && (
        <path d={`M0 ${y(0)}H${W}`} stroke="#9fc1ee" strokeWidth={1} strokeDasharray="4 3" {...stroke} />
      )}
      {props.area && (
        <path
          d={`${line}L${x(pts[pts.length - 1][0])} ${H}L${x(pts[0][0])} ${H}Z`}
          fill={props.color}
          fillOpacity={0.1}
        />
      )}
      <path d={line} stroke={props.color} strokeWidth={1.75} {...stroke} />
    </svg>
  );
}
